import {
    LIST_RESULT_MODALITIES,
    LIST_RESULT_MODALITIES_SUCCESS,
    LIST_RESULT_MODALITIES_ERROR,
    ADD_RESULT_MODALITIES,
    SAVE_RESULT_MODALITIES,
    SAVE_RESULT_MODALITIES_SUCCESS,
    SAVE_RESULT_MODALITIES_ERROR,
    DELETE_RESULT_MODALITIES,
    DELETE_RESULT_MODALITIES_SUCCESS,
    DELETE_RESULT_MODALITIES_ERROR,
    EDIT_RESULT_MODALITIES,
    UPDATE_RESULT_MODALITIES,
    UPDATE_RESULT_MODALITIES_SUCCESS,
    UPDATE_RESULT_MODALITIES_ERROR
} from '../types';

import clienteAxios from '../config/axios';
import authToken from '../config/token';

import resultModalitiesData from '../data/resultModalities';
import { ErrorMessage, SuccessMessage, WaitingMessage } from '../components/extras/toastMessages';
import { MSG_CREATE_SUCCESS, MSG_UPDATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS } from '../constants/messages';
import Swal from 'sweetalert2';
import { METHOD_DISABLED } from '../constants/requestMethods';

const controller = 'modalidad';

//LISTAR AUDIENCE MOTIVES
export function listResultModalitiesAction(params) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listResultModalities() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`, { params });
            //Obtengo los datos
            const resultModalities = response.data;
            //const resultModalities = resultModalitiesData;
            //Llamo al dispatch
            dispatch( listResultModalitiesSuccess(resultModalities.content) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listResultModalitiesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listResultModalities = () => ({
    type: LIST_RESULT_MODALITIES,
    payload: true
});

const listResultModalitiesSuccess = resultModalities => ({
    type: LIST_RESULT_MODALITIES_SUCCESS,
    payload: resultModalities
});

const listResultModalitiesError = error => ({
    type: LIST_RESULT_MODALITIES_ERROR,
    payload: error
});

//ADD AUDIENCE MOTIVE
export function addResultModalitiesAction(showForm) {
    return (dispatch) => {
        //Inicializo
        dispatch( addResultModalities(false) );
        //Abro el formulario
        showForm();
    }
}

const addResultModalities = isEdit => ({
    type: ADD_RESULT_MODALITIES,
    payload: isEdit
});

//SAVE AUDIENCE MOTIVE
export function saveResultModalitiesAction(resultModality, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( saveResultModalities() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.post(`/${controller}`, resultModality);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( saveResultModalitiesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_CREATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( saveResultModalitiesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const saveResultModalities = () => ({
    type: SAVE_RESULT_MODALITIES,
    payload: true
});


const saveResultModalitiesSuccess = resultModality => ({
    type: SAVE_RESULT_MODALITIES_SUCCESS,
    payload: resultModality
});

const saveResultModalitiesError = error => ({
    type: SAVE_RESULT_MODALITIES_ERROR,
    payload: error
});

//EDIT AUDIENCE MOTIVE
export function editResultModalitiesAction(resultModality, showForm) {
    return async (dispatch) => {
        //Inicializo
        dispatch( editResultModalities(resultModality) );
        //Abro el formulario
        showForm();
    }
}

const editResultModalities = resultModality => ({
    type: EDIT_RESULT_MODALITIES,
    payload: resultModality
});

//UPDATE AUDIENCE MOTIVE
export function updateResultModalitiesAction(resultModality, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( updateResultModalities() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/${resultModality.id}`, resultModality);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( updateResultModalitiesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( updateResultModalitiesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const updateResultModalities = () => ({
    type: UPDATE_RESULT_MODALITIES,
    payload: true
});

const updateResultModalitiesSuccess = resultModality => ({
    type: UPDATE_RESULT_MODALITIES_SUCCESS,
    payload: resultModality
});

const updateResultModalitiesError = error => ({
    type: UPDATE_RESULT_MODALITIES_ERROR,
    payload: error
});

//DELETE AUDIENCE MOTIVE
export function deleteResultModalitiesAction(resultModality) {
    return async (dispatch) => {
        //Inicializo
        dispatch( deleteResultModalities() );
        //Mensaje de Espera
        WaitingMessage(MSG_DELETING);
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            // const response = await clienteAxios.delete(`/${controller}/${resultModality.id}`);
            const response = await clienteAxios.put(`/${controller}/${resultModality.id}/${METHOD_DISABLED}`);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( deleteResultModalitiesSuccess(response.data) );
            //Oculto espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_DELETE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( deleteResultModalitiesError(data) );
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const deleteResultModalities = () => ({
    type: DELETE_RESULT_MODALITIES,
    payload: true
});

const deleteResultModalitiesSuccess = resultModality => ({
    type: DELETE_RESULT_MODALITIES_SUCCESS,
    payload: resultModality
});

const deleteResultModalitiesError = error => ({
    type: DELETE_RESULT_MODALITIES_ERROR,
    payload: error
});